





















































































import {
  computed,
  ref,
  defineComponent,
  PropType,
} from '@nuxtjs/composition-api'

import { debounce } from 'throttle-debounce'
import { VueMaskDirective } from 'v-mask'
import { v4 as guid } from 'uuid'
import { validators } from '@/validation'
import Link from '@/components/Link.vue'
import { FormInputText, emptyFormInputText } from '@/contracts/FormInput'
import InputCheckbox from '@/components/Inputs/InputCheckbox.vue'

const EMAIL_SERVICE_URL = 'https://sendsay.ru/form/rgsru/1'

export default defineComponent({
  name: 'BlockSubscribeForm',
  components: {
    InputCheckbox,
    Link,
  },
  directives: {
    mask: VueMaskDirective,
  },
  props: {
    form: {
      type: Object as PropType<FormInputText>,
      default: () => emptyFormInputText(),
    },
  },

  setup() {
    const checkboxId = guid()
    const inputId = guid()

    const isFocused = ref(false)
    const isAcceptPrivacy = ref(false)

    const email = ref('')
    const errors = ref<boolean[]>([
      validators.required(email.value, 'Почтовый адрес обязательное поле'),
      validators.email(email.value),
      validators.required(
        isAcceptPrivacy.value,
        'Обязательно подтвердите соглашение с условиями'
      ),
    ])
    const showError = ref(false)
    const invalidForm = computed(() => errors.value.find((item) => !!item))

    const privacyTitle = 'Я соглашаюсь с условиями'
    const privacyLabel = 'правил рассылок'
    const policyUrl = '/policy-subscribe'

    const checkErrors = () => {
      errors.value = [
        validators.required(email.value, 'Почтовый адрес обязательное поле'),
        validators.email(email.value),
        validators.required(
          isAcceptPrivacy.value,
          'Обязательно подтвердите соглашение с условиями'
        ),
      ]
    }

    const submitPrevent = (event: SubmitEvent) => {
      checkErrors()

      if (invalidForm.value) {
        showError.value = true
      } else {
        const formEl = event.target as HTMLFormElement
        formEl.submit()
      }
    }

    const onCheckboxInput = (val: boolean) => {
      isAcceptPrivacy.value = val
      checkErrors()
    }

    const debouncedSubmitHandler = computed(() => debounce(500, submitPrevent))

    return {
      EMAIL_SERVICE_URL,
      invalidForm,
      showError,
      debouncedSubmitHandler,
      isAcceptPrivacy,
      privacyTitle,
      privacyLabel,
      policyUrl,
      onCheckboxInput,
      errors,
      checkboxId,
      inputId,
      checkErrors,
      isFocused,
      email,
    }
  },
})
